import type { FC } from 'react';
import UserAvatar, { type UserAvatarProps } from './UserAvatar';
import { useAvatarMeta } from './useAvatarMeta';

type KeyedUserAvatarProps = Omit<UserAvatarProps, 'userKey' | 'hasImage' | 'photoVersion'> & { userKey: string };

/** Аватар по ключу АК: есть ли фото и его версию берёт из метаданных пачкой (useAvatarMeta). */
const KeyedUserAvatar: FC<KeyedUserAvatarProps> = ({ userKey, ...props }) => {
    const meta = useAvatarMeta(userKey);
    return (
        <UserAvatar
            {...props}
            userKey={userKey}
            hasImage={meta?.hasImage ?? false}
            photoVersion={meta?.photoVersion ?? undefined}
        />
    );
};

export default KeyedUserAvatar;
